export default "__VITE_ASSET__CPkiszVi__"